var map = {
	"./symbol_0.png": "4283",
	"./symbol_1.png": "96bc",
	"./symbol_2.png": "2b89",
	"./symbol_3.png": "d45d",
	"./symbol_4.png": "f9c7",
	"./symbol_5.png": "bb8d",
	"./symbol_6.png": "a615",
	"./symbol_7.png": "5972",
	"./symbol_8.png": "8863",
	"./symbol_9.png": "bb54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5fc";